import { observer } from 'mobx-react-lite';

import { Button, Image } from 'semantic-ui-react';
import { useStore } from '../../../stores/store';
import { userLanguage } from '../../userLanguageSchema/userLanguage';

function RfidScanner() {
  const { dashboardStore, commonStore } = useStore();

  return (
    <>
      <Image
        style={{
          width: '150px',
          height: '125px',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginBottom: '0px',
        }}
        size="small"
        src="/assets/createModify/passive_rfid.png"
        centered
      />
      <Button
        fluid
        color="teal"
        pointing="top"
        icon="barcode"
        onClick={() => dashboardStore.setOpenRfidScanner(true)}
        content={
          (userLanguage[0].Level3InventoryRecievingTag?.IRTB05 as any)?.[
            `${commonStore.language.key}`
          ]
        } //"Scan"
        style={{
          width: '150px',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      />
    </>
  );
}

export default observer(RfidScanner);
